
export enum AppRoutes {
  Application = "app",
  Login = "login",
  Error = "error"
};
